import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { AccountSelectContainer } from './containers/AccountSelectContainer';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { HelpContainer } from '../HelpContainer';
import { trackAccountSelectNeedHelp, trackAccountSelectOpen } from './tracking';
import { RootContext } from '../RootContainer';
import { AccountSelectViewLayout } from '../../components/AccountSelectViewLayout';
import { UIHeading2 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AccountSelectView = function AccountSelectView(_ref) {
  var source = _ref.source;
  var _React$useContext = React.useContext(RootContext),
    isRedesignExperimentEnabled = _React$useContext.isRedesignExperimentEnabled;
  React.useEffect(function () {
    if (!isRedesignExperimentEnabled) {
      trackAccountSelectOpen(source);
    }
  }, []);
  var handleHelpClick = React.useCallback(function () {
    return trackAccountSelectNeedHelp(source);
  }, [source]);
  if (isRedesignExperimentEnabled) {
    return /*#__PURE__*/_jsx(AccountSelectViewLayout, {
      title: /*#__PURE__*/_jsx(UIHeading2, {
        children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
      }),
      content: /*#__PURE__*/_jsx(AccountSelectContainer, {
        isRedesignExperimentEnabled: true
      }),
      help: /*#__PURE__*/_jsx(HelpContainer, {
        indent: "L",
        onClick: handleHelpClick
      })
    });
  }
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(SubtitleLayout, {
      children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
    }), /*#__PURE__*/_jsx(AccountSelectContainer, {}), /*#__PURE__*/_jsx(HelpContainer, {
      onClick: handleHelpClick
    })]
  });
};